import { Post } from "../core/Helper";

export class StudyMessageService {
  static async CheckRadioValidMessage(params) {
    let result = await Post("api/notify-message/check-valid-message", params);
    return (await result) ?? null;
  }
}
